// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"21415016","977":"b672a989"}[chunkId] + ".chunk.js";
};